import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { OfferServices } from "../services/OfferServices";

const OfferCard = ({ thumb, title, deliveryText, to, btnText }) => (
  <div
    className="offer-card position-relative rounded-16 overflow-hidden p-24 d-flex align-items-center gap-20 flex-nowrap z-1"
    style={{
      background: "linear-gradient(135deg, #299e60 0%, #1d7a49 100%)",
      border: "1px solid #1d7a49",
    }}
  >
    {/* Decorative soft circle */}
    <div
      style={{
        position: "absolute",
        top: "-60px",
        right: "-60px",
        width: "220px",
        height: "220px",
        borderRadius: "50%",
        background: "rgba(255,255,255,0.07)",
        pointerEvents: "none",
      }}
    />
    <div
      style={{
        position: "absolute",
        bottom: "-40px",
        left: "30%",
        width: "140px",
        height: "140px",
        borderRadius: "50%",
        background: "rgba(255,255,255,0.05)",
        pointerEvents: "none",
      }}
    />

    {/* Thumb — hidden on mobile */}
    {thumb && (
      <div
        className="offer-card__thumb d-lg-block d-none"
        style={{
          width: "180px",
          flexShrink: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img
          src={thumb}
          alt={title}
          style={{
            width: "100%",
            height: "auto",
            objectFit: "contain",
            filter: "drop-shadow(0 8px 20px rgba(0,0,0,0.18))",
          }}
        />
      </div>
    )}

    {/* Content */}
    <div className="py-xl-4" style={{ position: "relative", zIndex: 1 }}>
      {/* Badge */}
      <span
        style={{
          display: "inline-block",
          fontSize: "11px",
          fontWeight: 700,
          letterSpacing: "0.12em",
          textTransform: "uppercase",
          color: "#299e60",
          background: "#f3faf2",
          borderRadius: "100px",
          padding: "4px 12px",
          marginBottom: "12px",
        }}
      >
        Special Offer
      </span>

      <h4
        style={{
          color: "#fff",
          fontWeight: 800,
          fontSize: "20px",
          lineHeight: 1.25,
          marginBottom: "8px",
        }}
      >
        {title}
      </h4>

      {deliveryText && (
        <p
          style={{
            color: "rgba(255,255,255,0.78)",
            fontSize: "14px",
            marginBottom: "20px",
            lineHeight: 1.5,
          }}
        >
          {deliveryText}
        </p>
      )}

      <Link
        to={to}
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "8px",
          padding: "10px 22px",
          borderRadius: "100px",
          background: "#f3faf2",
          color: "#14532d",
          fontWeight: 700,
          fontSize: "14px",
          textDecoration: "none",
          transition: "all 0.2s ease",
          border: "1px solid rgba(255,255,255,0.3)",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = "#fff";
          e.currentTarget.style.boxShadow = "0 4px 16px rgba(0,0,0,0.15)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = "#f3faf2";
          e.currentTarget.style.boxShadow = "none";
        }}
      >
        {btnText}
        <i className="ph ph-arrow-right" style={{ fontSize: "16px" }} />
      </Link>
    </div>
  </div>
);

const OfferOne = () => {
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchOffers = async () => {
    try {
      setLoading(true);
      const data = await OfferServices.getAllOffers();
      setOffers(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Failed to fetch offers:", error);
      setOffers([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOffers();
  }, []);

  if (loading) {
    return (
      <section className="offer pt-80 pb-80">
        <div className="container container-lg">
          <div className="text-center" style={{ color: "#3d7a52" }}>
            Loading offers...
          </div>
        </div>
      </section>
    );
  }

  if (!loading && offers.length === 0) return null;

  return (
    <section className="offer pt-80 pb-80">
      <style>{`
        .offer-card {
          transition: transform 0.22s ease, box-shadow 0.22s ease;
        }
        .offer-card:hover {
          transform: translateY(-3px);
          box-shadow: 0 16px 40px rgba(41,158,96,0.22) !important;
        }
      `}</style>

      <div className="container container-lg">
        <div className="row gy-4">
          {offers.map((offer) => (
            <div className="col-sm-6" key={offer.id}>
              <OfferCard
                thumb={offer.image_url}
                title={offer.title}
                deliveryText={offer.subtitle}
                to="/shop"
                btnText="Shop Now"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OfferOne;